// extracted by mini-css-extract-plugin
export var footer = "_px-5";
export var fulfillmentInput = "_px-0";
export var shipDateInput = "_px-1";
export var shipmentModal = "_px-2";
export var shipmentModalContent = "_px-3";
export var tableContainer = "_px-4";